import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import ToolbarMenu from './ToolbarMenu';
import styles from '../styles.module.css';
import ToolButton from './ToolButton';
import WhiteboardController from '../controllers/WhiteboardController';

// Stylus toolbar sub-menu for choosing a connector.
const ConnectorMenu = () => {
  const controller = useController(WhiteboardController);
  const { shapeDragManager } = controller;

  return (
    <ToolbarMenu columns={1}>
      {controller.connectorStyluses.map((stylus, i) => (
        <ToolButton
          className={styles.toolButton}
          draggable={true}
          onDragStart={e => shapeDragManager.startDrag(e, stylus)}
          key={i}
          onClick={event => {
            controller.actionSetStylus(stylus);
            controller.actionSetStylusMenu(null);
            event.stopPropagation();
          }}
        >
          {stylus.renderIcon()}
        </ToolButton>
      ))}
    </ToolbarMenu>
  );
};

export default ApplicationView(ConnectorMenu);
